import { render, staticRenderFns } from "./AdminNew.vue?vue&type=template&id=6f94307c&scoped=true"
import script from "./AdminNew.vue?vue&type=script&lang=js"
export * from "./AdminNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f94307c",
  null
  
)

export default component.exports